import React, { Component } from 'react';
import ReactRouterPropTypes from 'react-router-prop-types';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  getSoftwareProductCodes,
  createSoftware,
} from 'admin/actions/softwares';
import LabeledSelect from 'admin/components/molecules/LabeledSelect';
import LabeledTextBox from 'admin/components/molecules/LabeledTextBox';
import _Select, { addNullOption } from 'admin/components/atoms/Select';
import TextBox from 'admin/components/atoms/TextBox';
import Breadcrumb from 'admin/components/shared/Breadcrumb';
import Button from 'admin/components/shared/Button';
import { openAlertModal } from 'admin/actions/alert-modal';

const LabelText = styled.span`
  font-weight: 600;
`;

const Forms = styled.div`
  ${LabeledSelect} {
    margin: 20px;
  }
  ${_Select} {
    width: 300px;
    margin-left: 10px;
  }
  ${LabeledTextBox} {
    margin: 20px;
  }
  ${TextBox} {
    width: 300px;
    height: 42px;
    margin-left: 10px;
    padding-left: 10px;
  }
`;

const ButtonsContainer = styled.div`
  button {
    margin-left: 10px;
  }
`;

const ConfirmNewTable = styled.table`
  width: 100%;
  td {
    padding: 10px;
    border-bottom: 1px solid #EEE;
    text-align: left;
  }
`;

const unselect = { label: '選択して下さい', value: null };

class CreateSoftware extends Component {

  constructor(props) {
    super(props);
    this.defaultPagination = { page: 1, per_page: 25 };
    this.state = {
      selectedProductCode: unselect,
      targetHardware: '',
      versionCode: '',
      url: '',
    };
  }

  refreshState() {
    this.setState({
      selectedProductCode: unselect,
      targetHardware: '',
      versionCode: '',
      url: '',
    });
  }

  componentWillMount() {
    this.props.getSoftwareProductCodes();
  }

  onChangeProductCode = (op) => {
    this.setState({
      selectedProductCode: op,
    });
  }

  onChangeTargetHardware = (e) => {
    this.setState({
      targetHardware: e.target.value,
    });
  }

  onChangeVersionCode = (e) => {
    this.setState({
      versionCode: e.target.value,
    });
  }

  onChangeURL = (e) => {
    this.setState({
      url: e.target.value,
    });
  }

  checkValue = () => {
    const errors = {};
    if (!this.state.selectedProductCode.value) {
      errors['プロダクトコード'] = '選択して下さい';
    }
    if (this.state.targetHardware === '') {
      errors['ハードウェア'] = '入力して下さい';
    }
    if (this.state.versionCode === '') {
      errors['バージョンコード'] = '入力して下さい';
    }
    if (this.state.url === '') {
      errors['バイナリURL'] = '入力して下さい';
    } else if (!this.state.url.match(/^https?:\/\//)) {
      errors['バイナリURL'] = '不正なURLです';
    }
    return errors;
  }

  onClickedNew = () => {
    const errors = this.checkValue();
    if (Object.keys(errors).length > 0) {
      this.props.openAlertModal({
        body: (
          <div>
            <strong>入力を確認して下さい</strong>
            <ConfirmNewTable>
              <tbody>
              {
                Object.keys(errors).map(k => (
                  <tr key={k}>
                    <td>{k}</td>
                    <td>{errors[k]}</td>
                  </tr>
                ))
              }
              </tbody>
            </ConfirmNewTable>
          </div>
        ),
        useCancel: false,
        confirmText: 'OK',
      });
      return;
    }
    this.props.openAlertModal({
      body: (
        <div>
          <strong>以下の情報で登録してよろしいですか？</strong>
          <ConfirmNewTable>
            <tbody>
              <tr>
                <td>プロダクトコード</td>
                <td>{this.state.selectedProductCode.value}</td>
              </tr>
              <tr>
                <td>ハードウェア</td>
                <td>{this.state.targetHardware}</td>
              </tr>
              <tr>
                <td>バージョンコード</td>
                <td>{this.state.versionCode}</td>
              </tr>
              <tr>
                <td>バイナリURL</td>
                <td>{this.state.url}</td>
              </tr>
            </tbody>
          </ConfirmNewTable>
        </div>
      ),
      useCancel: true,
      confirmText: '登録する',
      onConfirm: () => {
        this.props.createSoftware({
          product_code: this.state.selectedProductCode.value,
          target_hardware: this.state.targetHardware,
          version_code: this.state.versionCode,
          url: this.state.url,
        }).then(() => {
          this.props.openAlertModal({
            body: '完了しました',
            useCancel: false,
            onConfirm: () => {
              this.refreshState();
            },
          });
        });
      },
    });
  }

  onClickedCancel = () => {
    this.props.history.goBack();
  }

  render() {
    const crumb = [
      { value: 'ホーム', href: '/', active: false },
      { value: 'サービス管理', href: '', active: true },
      { value: 'ソフトウェアビルド管理', href: '/service-settings/software', active: false },
      { value: '新規登録', href: '/service-settings/software/create', active: true },
    ];
    return (
      <div>
        <Breadcrumb items={crumb} />
        <Forms>
          <LabeledSelect
            labelText={(<LabelText>プロダクト</LabelText>)}
            options={
            addNullOption(this.props.softwareProductCodes.map(m => ({
              label: m,
              value: m,
            })), '選択して下さい')
            }
            value={this.state.selectedProductCode}
            onChange={this.onChangeProductCode}
          />
          <LabeledTextBox
            labelText={(<LabelText>ハードウェア</LabelText>)}
            syncValue={this.state.targetHardware}
            onChange={this.onChangeTargetHardware}
          />
          <LabeledTextBox
            labelText={(<LabelText>バージョンコード</LabelText>)}
            syncValue={this.state.versionCode}
            onChange={this.onChangeVersionCode}
          />
          <LabeledTextBox
            labelText={(<LabelText>バイナリURL</LabelText>)}
            syncValue={this.state.url}
            onChange={this.onChangeURL}
          />
        </Forms>
        <ButtonsContainer>
          <Button onClick={this.onClickedNew}>
            新しいビルドを登録
          </Button>
          <Button onClick={this.onClickedCancel} color="gray">
            キャンセル
          </Button>
        </ButtonsContainer>
      </div>
    );
  }
}

CreateSoftware.defaultProps = {
  softwares: { rows: [], count: 0, pagination: { current: 1, per_page: 30 } },
  softwareProductCodes: [],
};

const mapStateToProps = state => ({
  softwares: state.software.softwares,
  softwareProductCodes: state.software.softwareProductCodes,
});

CreateSoftware.propTypes = {
  openAlertModal: PropTypes.func.isRequired,
  getSoftwareProductCodes: PropTypes.func.isRequired,
  createSoftware: PropTypes.func.isRequired,
  softwareProductCodes: PropTypes.arrayOf(PropTypes.string),
  softwares: PropTypes.shape({
    rows: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      product_code: PropTypes.string,
      target_hardware: PropTypes.string,
      version_code: PropTypes.string,
      url: PropTypes.string,
      created_at: PropTypes.string,
      updated_at: PropTypes.string,
    })),
    count: PropTypes.number,
    pagination: PropTypes.shape({
      current: PropTypes.number,
      per_page: PropTypes.number,
    }),
  }),
  match: PropTypes.shape({
    params: PropTypes.object,
  }).isRequired,
  history: ReactRouterPropTypes.history.isRequired,
};

const mapDispatchToProps = dispatch => bindActionCreators({
  getSoftwareProductCodes,
  createSoftware,
  openAlertModal,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CreateSoftware);
